<template>
  <div class="shane_tm_section">
    <div class="shane_tm_copyright">
      <div class="container">
        <div class="inner">
          <b-row>
            <b-col lg="4">
                <div>
                Katherine Pacitti
              </div>
              <div style="margin-bottom: 20px;">
                <b>Strategic Communications & Public Relations Professional</b>
              </div>
            </b-col>
            <b-col lg="4">
                <div>
                Email
              </div>
              <div style="margin-bottom: 20px;">
                <b>katgpacitti@gmail.com</b>
              </div>
            </b-col>
            <b-col lg="4">
              <div>
                Phone
              </div>
              <div>
                <b>(941) 779-7253</b>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- End inner -->
      </div>
    </div>
    <!-- End shane_tm_copyright -->
  </div>
</template>

<script>
import {BRow, BCol,} from 'bootstrap-vue'
export default {
  components: {
    BRow,
    BCol,
  }
}
</script>

<style lang="scss" scoped></style>
